import { useState, useCallback } from "react";

export default function useForceUpdate() {
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);

  return forceUpdate;
}
